import {NgModule} from '@angular/core';
import {
  AsFormGroup,
  IsNilOrEmpty,
  SortByKeyPipe,
  GetHumanFormatedDate,
  AsFormControl,
  Filter,
  IsPrimitive
} from './utils.pipe';
import {GetCost, GetPrice} from './batch.pipe';
import {MissionTypeTranslatePipe} from './mission-type-translate.pipe';
import {GetFirstMissionType, GetSecondMissionType} from './order.pipe';
import {
  GetCustomValueLabelPipe,
  GetDateLabelHtmlPipe,
  GetUnitLabel,
  GetValuesForUnit,
  IsRangeDate
} from './date-filter.pipe';
import {HasValidator} from './has-validator.pipe';
import {HumanDuration} from './duration.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { CreatorFormatPipe } from './creator-format.pipe';
import { IdFormatPipe } from './id-format.pipe';
import { UpdatedAtDateFormatPipe } from './updated-at-date-format.pipe';
import { SubTypeFormatPipe } from './sub-type-format.pipe';
import { PlateNumberFormatPipe } from './plate-number-format.pipe';
import { ValetFormatPipe } from './valet-format.pipe';
import { CustomerFormatPipe } from './customer-format.pipe';
import { CommentFormatPipe } from './comment-format.pipe';
import { DocumentFormatPipe } from './document-format.pipe';
import { AnomalyTypeFormatPipe } from './anomaly-type-format.pipe';
import { MissionNameFormatPipe } from './mission-name-format.pipe';
import { MissionLogTypePipe } from './mission-log-type.pipe';
import { ClientAnomalyStageFormatPipe } from './client-anomaly-stage-format.pipe';
import { CapabilitiesJoinPipe } from './capabalities-join.pipe';
import { DateWithFallbackPipe } from './date-with-fallback.pipe';
import { LookupPipe } from './lookup.pipe';
import {CleanHtmlContentPipe} from './clean-html-content.pipe';
import {AlertLabelPipe} from './alert-label.pipe';

@NgModule({
  declarations: [
    IsNilOrEmpty,
    GetCost,
    GetPrice,
    SortByKeyPipe,
    AsFormGroup,
    AsFormControl,
    MissionTypeTranslatePipe,
    GetFirstMissionType,
    GetSecondMissionType,
    GetValuesForUnit,
    GetUnitLabel,
    GetDateLabelHtmlPipe,
    GetCustomValueLabelPipe,
    IsRangeDate,
    HasValidator,
    GetHumanFormatedDate,
    Filter,
    HumanDuration,
    IsPrimitive,
    DateFormatPipe,
    CreatorFormatPipe,
    IdFormatPipe,
    UpdatedAtDateFormatPipe,
    SubTypeFormatPipe,
    PlateNumberFormatPipe,
    ValetFormatPipe,
    CustomerFormatPipe,
    CommentFormatPipe,
    DocumentFormatPipe,
    AnomalyTypeFormatPipe,
    MissionNameFormatPipe,
    MissionLogTypePipe,
    ClientAnomalyStageFormatPipe,
    CapabilitiesJoinPipe,
    DateWithFallbackPipe,
    LookupPipe,
    CleanHtmlContentPipe,
    AlertLabelPipe
  ],
  exports: [
    IsNilOrEmpty,
    GetCost,
    GetPrice,
    SortByKeyPipe,
    AsFormGroup,
    AsFormControl,
    MissionTypeTranslatePipe,
    GetFirstMissionType,
    GetSecondMissionType,
    GetValuesForUnit,
    GetUnitLabel,
    GetDateLabelHtmlPipe,
    GetCustomValueLabelPipe,
    IsRangeDate,
    HasValidator,
    GetHumanFormatedDate,
    Filter,
    HumanDuration,
    IsPrimitive,
    DateFormatPipe,
    CreatorFormatPipe,
    IdFormatPipe,
    UpdatedAtDateFormatPipe,
    SubTypeFormatPipe,
    PlateNumberFormatPipe,
    ValetFormatPipe,
    CustomerFormatPipe,
    CommentFormatPipe,
    DocumentFormatPipe,
    AnomalyTypeFormatPipe,
    MissionNameFormatPipe,
    MissionLogTypePipe,
    ClientAnomalyStageFormatPipe,
    CapabilitiesJoinPipe,
    DateWithFallbackPipe,
    LookupPipe,
    CleanHtmlContentPipe,
    AlertLabelPipe
  ],
})
export class PipesModule {
}
